// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"487":"e3caac4fcc6daf80","1949":"de7781e1b83c3a80","9079":"984ed61cd2289f29"}[chunkId] + ".css";
};